jQuery(document).ready(function($) {

	carouselWorks($, '.carousel-works');
	thumbCarousel($, '.carousel-clients');
	carouselValues($, '.carousel-values');
	carouselImage($, '.carousel-image');
});

function carouselValues($, sliderSelector) {

	const swiper = new Swiper(sliderSelector, {
		loop: true,
		slidesPerView: 1,
		breakpoints: {
			'@0.75': {
			  slidesPerView: 2
			},
		},
		//slidesPerColumn: 2,
		speed: 3000,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
		//slidesPerColumnFill: 'row',
		autoplay: {
			delay: 3000,
		},
	});

}

function carouselImage($, sliderSelector) {

	const swiper = new Swiper(sliderSelector, {
		loop: true,
		speed: 1600,
		disableOnInteraction:true,
		autoplay: {
			delay: 5000,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: false
		},
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
	});

	$(".swiper-container").hover(function() {
		(this).swiper.autoplay.stop();
	}, function() {
		(this).swiper.autoplay.start();
	});

	

}

function carouselWorks($, sliderSelector) {

	const swiper = new Swiper(sliderSelector, {
		loop: true,
		speed: 1600,
		autoplay: {
			delay: 5000,
		},
		//autoHeight: true,
		effect: 'fade',
		fadeEffect: {
		  crossFade: true
		},
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
	});

}

function thumbCarousel($, sliderSelector) {

	const thumbsSelector = sliderSelector + '-thumbs';

	const thumbs = new Swiper(thumbsSelector, {
		spaceBetween: µSpacer(0.5),
		slidesPerView: 4,
		loop: false,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	const slider = new Swiper(sliderSelector, {
		spaceBetween: µSpacer(0.5),
		loop: true,
		speed: 1600,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: thumbs,
		},
	});

}